import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { provideIcons } from '@ng-icons/core';
import { lucidePlus } from '@ng-icons/lucide';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmFieldImports } from '@spartan-ng/helm/field';
import { HlmIconImports } from '@spartan-ng/helm/icon';

import { ActivitéFormService } from '../activité-form.service';
import { AptitudeGroupComponent } from '../aptitude-group/aptitude-group.component';

@Component({
  selector: 'app-aptitudes',
  imports: [AptitudeGroupComponent, ReactiveFormsModule, HlmFieldImports, HlmButtonImports, HlmIconImports],
  templateUrl: './aptitudes.component.html',
  providers: [provideIcons({ lucidePlus })],
})
export class AptitudesComponent {
  readonly form = input.required<FormGroup>();
  readonly formService = input.required<ActivitéFormService>();
}
